import "@/scripts/array-operations"

export enum NotificationType {
	General,
	RecordAssignedToUser,
	RecordUpdatedByAnotherUser,
	RuleAction
}

export enum Urgency {
	Low,
    Medium,
    High,
    Critical
}

export const UrgencyLabels = [
	{
		key: Urgency.Critical,
		label: "Critical"
	},
	{
		key: Urgency.High,
		label: "High"
	},
	{
		key: Urgency.Medium,
		label: "Medium"
	},
	{
		key: Urgency.Low,
		label: "Low"
	}
]

const urgencyByValue = UrgencyLabels.toDictionary("key")
export const notificationFunctions = {
	urgencyToString (urgency: Urgency | null): string | null {
		if (urgency == null) return null
		return urgencyByValue[urgency].label
	},
	highestUrgency (urgency: CasesNotification[]): Urgency | null {
		return urgency && urgency.length > 0 ? urgency[0].urgency! : null
	}
}

export interface CasesNotification {
	id: string;
	created: Date;
	type: NotificationType;
	title: string;
	message: string;
	data: any;
	targetId: string;
	sentDateTime: Date | null;
	sent?: boolean | null;
	deleted?: boolean | null;
	urgency?: Urgency | null;
}
